import { localStorageKeys } from '../utils/common'
import { debounce } from './common'

export let reducers = {}
export let persist = {}
let emitChange = null

export const register = (name, reducer, persistKeys) => {
  if (persistKeys) persist[name] = persistKeys
  reducers = { ...reducers, [name]: reducer }
  if (emitChange) {
    emitChange(reducers)
  }
}

export const setChangeListener = (listener) => {
  emitChange = listener
}

export const syncInitialState = ({
  name,
  initialState,
  persistKeys,
  persistKeysDisableCheckLocation,
}) => {
  const data = getStoragePersistData()[name]
  if (!data) {
    return initialState
  }

  if (!persistKeys) {
    persistKeys = Object.keys(initialState)
  }

  if (
    localStorage.getItem(localStorageKeys.CURRENT_LOCATION) !==
    window.location.pathname + window.location.search
  ) {
    if (!persistKeysDisableCheckLocation) {
      return initialState
    } else {
      persistKeys = persistKeysDisableCheckLocation
    }
  }

  return persistKeys.reduce(
    (prev, curr) =>
      data.hasOwnProperty(curr) ? { ...prev, [curr]: data[curr] } : prev,
    { ...initialState },
  )
}

export const getStatePersistData = (state) => {
  return Object.keys(persist).reduce(
    (data, key) => ({
      ...data,
      [key]: persist[key].reduce(
        (sliceData, sliceKey) => ({
          ...sliceData,
          [sliceKey]: state[key][sliceKey],
        }),
        {},
      ),
    }),
    {},
  )
}

export const getStoragePersistData = () => {
  return (
    JSON.parse(localStorage.getItem(localStorageKeys.KEY_PERSIST_STORE)) || {}
  )
}

export const setStoragePersistData = (data) => {
  localStorage.setItem(localStorageKeys.KEY_PERSIST_STORE, JSON.stringify(data))
}

export const debounceSetStoragePersistData = debounce((store) => {
  const stateData = getStatePersistData(store.getState())
  const storageData = getStoragePersistData()
  setStoragePersistData({ ...storageData, ...stateData })
}, 500)
